export default "__VITE_ASSET__5HTtortM__"